module.exports = __webpack_public_path__ + "img/1-1.a92b8377.png";